import { Injectable } from '@angular/core';

export type DarkMode = 'on' | 'off' | 'system';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private darkMode = false;
  private mode: DarkMode = 'system';

  constructor() {
    this.init();
  }

  getMode() {
    return this.mode;
  }

  async setMode(mode: DarkMode) {
    this.mode = mode;
    localStorage.setItem('darkMode', mode);
    switch (mode) {
      case 'on':
        this.setDarkMode(true);
        break;
      case 'off':
        this.setDarkMode(false);
        break;
      default:
        this.checkPrefersColorScheme();
        break;
    }
  }

  async init() {
    const storedMode = localStorage.getItem('darkMode') ?? '';
    switch (storedMode) {
      case 'on':
        this.setDarkMode(true);
        this.mode = 'on';
        break;
      case 'off':
        this.setDarkMode(false);
        this.mode = 'off';
        break;
      default:
        this.mode = 'system';
        this.checkPrefersColorScheme();
    }
  }

  checkPrefersColorScheme() {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      this.setDarkMode(true);
    } else {
      this.setDarkMode(false);
    }
  }

  isDarkMode() {
    return this.darkMode;
  }

  setDarkMode(isDarkMode: boolean) {
    this.darkMode = isDarkMode;
    if (isDarkMode) {
      document.body.classList.add('dark');
      document.documentElement.classList.add('cc--darkmode');
      document.documentElement.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
      document.documentElement.classList.remove('cc--darkmode');
      document.documentElement.classList.remove('dark');
    }
  }
}